<template>
  <v-card :value="value" v-bind="$attrs" self-align="center" :style="'border: 1px solid ' + Colors.MenuTextColor">
    <v-card-actions v-if="!isOnMobile" class="ma-0 pa-0" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-1">
        {{ title }}
      </v-card-text>
    </v-card-actions>
    <t-divider></t-divider>
    <v-card-actions :style="'background: ' + Colors.MenuColor + '; color: ' + Colors.MenuTextColor" class="ma-0 pa-1" align="center" justify="center">
      <v-card-text class="subtitle-1 ma-0 pa-0">
        {{ datesText }}
      </v-card-text>
    </v-card-actions>
    <t-divider></t-divider>
    <v-card-actions class="ma-0 pa-0">
      <v-date-picker
        class="ma-0 pa-0"
        firstDayOfWeek="1"
        :picker-date="dateDisplayed"
        :selected-items-text="datesText"
        no-title
        locale="bg"
        mode="range"
        range
        v-model="datesString"
        :min="min.toStringWithFormat('yyyy-MM-dd')"
        :max="max.toStringWithFormat('yyyy-MM-dd')"
        show-current
      >
        <v-col class="ma-0 pa-0">
          <t-divider></t-divider>
          <v-row class="ma-0 pa-1" justify="center">
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded variant="outlined" small color="primary" v-on:click="setDates(0)">Днес</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded variant="outlined" small color="primary" v-on:click="setDates(1)">Вчера</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded variant="outlined" small color="primary" v-on:click="setDates(2)">Седмицата</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded variant="outlined" small color="primary" v-on:click="setDates(3)">Този месец</v-btn>
            <v-btn class="ma-1 pa-1" :class="isOnMobile ? 'caption pa-0' : ''" rounded variant="outlined" small color="primary" v-on:click="setDates(4)">Миналия месец</v-btn>
          </v-row>
          <t-divider></t-divider>
          <v-row :class="isOnMobile ? 'ma-0 pa-0' : 'ma-1 pa-0'">
            <v-spacer></v-spacer>
            <v-btn class="ma-1 pa-0" text variant="outlined" :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="cancelInput()">{{ buttonCancelText }}</v-btn>
            <v-btn class="ma-1 pa-0" text variant="outlined" :style="'background: ' + Colors.MenuColor" :class="Colors.MenuColor + '--text'" @click="handleInput()">{{ buttonOKText }}</v-btn>
          </v-row>
        </v-col>
      </v-date-picker>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [null, null],
    },
    label: {
      type: String,
      default: "От дата - до дата",
    },
    min: {
      type: Date,
      default: () => new Date().addMonths(-36),
    },
    max: {
      type: Date,
      default: () => new Date(),
    },
  },
  data() {
    return {
      title: "Избор на период",
      datesString: [null, null], //new Date().toStringWithFormat("yyyy-MM-dd"), new Date().toStringWithFormat("yyyy-MM-dd")],
      dates: [this.value[0], this.value[1]],
      datesLast: [this.value[0], this.value[1]],
      datesText: "Моля изберете период",
      dateDisplayed: undefined,
      buttonOKText: "ОК",
      buttonCancelText: "Отказ",
    };
  },
  methods: {
    click() {},
    setDates(type) {
      var date = new Date();
      this.datesString = [null, null];
      //this.$forceUpdate();
      switch (type) {
        case 0:
          this.datesString[0] = date.toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.toStringWithFormat("yyyy-MM-dd");
          break;

        case 1:
          this.datesString[0] = date.addDays(-1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;

        case 2:
          this.datesString[0] = date.getMonday().toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = date.toStringWithFormat("yyyy-MM-dd");
          break;

        case 3:
          this.datesString[0] = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = new Date().toStringWithFormat("yyyy-MM-dd"); // new Date(date.getFullYear(), date.getMonth(), 1).addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;

        case 4:
          this.datesString[0] = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 1).addMonths(-1).toStringWithFormat("yyyy-MM-dd");
          this.datesString[1] = new Date(date.getFullYear(), date.getMonth(), 1).addDays(-1).toStringWithFormat("yyyy-MM-dd");
          break;
      }
      this.$forceUpdate();
    },
    clearDates() {
      this.dates[0] = null;
      this.dates[1] = null;
      this.datesString[0] = null;
      this.datesString[1] = null;
      this.handleInput();
    },
    cancelInput() {
      if (this.datesLast[0]) this.datesString[0] = this.datesLast[0].toStringWithFormat("yyyy-MM-dd");
      else this.datesString[0] = null;
      if (this.datesLast[1]) this.datesString[1] = this.datesLast[1].toStringWithFormat("yyyy-MM-dd");
      else this.datesString[1] = null;
      this.dialog.result = null;
      this.dialog.close();
    },
    handleInput() {
      if ((this.datesString[0] && !this.datesString[1]) || (!this.datesString[0] && this.datesString[1])) {
        this.dialog.showError("Избрали сте само начална дата на диапазона, моля, изберете и крайна дата.");
        return;
      }
      if (!this.datesString[0] && !this.datesString[1]) {
        this.dialog.showError("Не сте избрали период!");
        return;
      }
      this.datesLast = this.dates.slice();
      this.dialog.result = this.dates;
      this.dialog.close();
    },
  },
  computed: {},
  watch: {
    value: {
      handler() {
        this.datesLast = this.value.slice();
        if (this.value[0] && this.value[1]) {
          this.datesString = [...[this.value[0].toStringWithFormat("yyyy-MM-dd"), this.value[1].toStringWithFormat("yyyy-MM-dd")]];
        } else {
          this.datesString = [null, null];
        }
      },
      deep: true,
    },
    datesString: {
      handler() {
        if (this.datesString[0]) {
          this.dates[0] = this.datesString[0].parseDateWithFormat("yyyy-MM-dd");
        } else {
          this.dates[0] = null;
        }
        if (this.datesString[1]) {
          this.dates[1] = this.datesString[1].parseDateWithFormat("yyyy-MM-dd");
        } else {
          this.dates[1] = null;
        }
        if (this.datesString[0] && this.datesString[1]) {
          this.dates[1] = this.datesString[1].parseDateWithFormat("yyyy-MM-dd");
          if (this.dates[0] > this.dates[1]) {
            this.datesString.reverse();
            this.dates.reverse();
          }
          this.dates[0] = this.dates[0].getDateWithoutTime();
          this.dates[1] = this.dates[1].getDateWithoutTime().addDays(1).addMilliseconds(-1);
          // console.log(this.dates[0].toTremolFpString());
          // console.log(this.dates[1].toTremolFpString());
          this.datesText = this.dates[0].toStringWithFormat("dd.MM.yyyy") + " - " + this.dates[1].toStringWithFormat("dd.MM.yyyy");
          // var dayz = Math.ceil((this.dates[1] - this.dates[0]) / (1000 * 60 * 60 * 24));
          // this.datesText = dayz > 1 ? "Общо " + dayz + " дни" : "1 ден"; //TODO?
        } else {
          this.datesText = (this.dates[0] ?? this.dates[1]).toStringWithFormat("dd.MM.yyyy");
        }
        this.dateDisplayed = this.dates[0] ? this.dates[0].toISOString() : new Date().toISOString();
        this.$nextTick(() => {
          this.dateDisplayed = undefined;
        });
      },
      deep: true,
    },
  },
  created() {
    if (this.dialog.data) {
      // this.dates = [...[this.dialog.data[0], this.dialog.data[1]]];
      this.datesString = [...[this.dialog.data[0].toStringWithFormat("yyyy-MM-dd"), this.dialog.data[1].toStringWithFormat("yyyy-MM-dd")]];
    }
    if (this.dialog.options) {
      if (this.dialog.options.title != undefined) {
        this.title = this.dialog.options.title;
      }
      if (this.dialog.options.buttonOKText != undefined) {
        this.buttonOKText = this.dialog.options.buttonOKText;
      }
      if (this.dialog.options.buttonCancelText != undefined) {
        this.buttonCancelText = this.dialog.options.buttonCancelText;
      }
      if (this.dialog.options.toString != undefined) {
        this.toStringFn = this.dialog.options.toStringFn;
      }
    }
  },
  mounted() {},
};
</script>
<style scoped>
</style>